module.exports = __webpack_public_path__ + "static/media/truck-container.f6dc6dd6.svg";